export default {
  state: {
    nextStep: false,
    onboarding_complete: false,
    data_wedding: {},
    answersOfStep: {
      step1: null,
      step3: null,
      step4: null,
      step7: null,
      step8: '',
      step9: 0,
    },
  },

  mutations: {
    SET_STEP(state, payload) {
      state.nextStep = payload
    },

    SET_DATA_WED(state, payload) {
      state.data_wedding = payload
    },

    SET_ANSWER(state, payload) {
      state.answersOfStep[payload.step] = payload.answer
    },

    SET_ONBOARDING_COMPLETE(state, payload) {
      state.onboarding_complete = payload
    },
  },

  actions: {
    setStep(context, payload) {
      context.commit('SET_STEP', payload)
    },

    dataWed(context, payload) {
      context.commit('SET_DATA_WED', payload)
    },

    setAnswer(context, payload) {
      context.commit('SET_ANSWER', payload)
    },

    setOnboardingComplete(context, payload) {
      context.commit('SET_ONBOARDING_COMPLETE', payload)
    },
  },
}
